module.exports = __webpack_public_path__ + "static/media/details-lightbox-1.a3f67ca2.png";